<template>
<p>
This page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it.<br/>
Thank you.
</p>
</template>

<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_011.vue?8f659730